const Main = ({children}) => {
  return <main>
    {children}
  </main>;
};

export default Main;